import { ApiClient } from "@/services/apiClient";
import type { CollectibleId } from "@/services/collectibles/collectiblesTypes";
import { CollectibleOwnedCountsResponse_Schema } from "@/services/collectibles/ownedCounts/ownedCountsSchema";
import type { CollectibleOwnedCountsResponse } from "@/services/collectibles/ownedCounts/ownedCountsTypes";

const AUTH_BASE = "api/collectible";

/**
 * Batch owned/marketplace-listed counts of the current user for the given collectibles.
 * Auth required; max 500 ids (400 above; axios serializes the array as collectibleIds[]=…).
 * Collectibles the user has no pieces of anywhere are omitted from items.
 */
export const fetchCollectibleOwnedCounts = async (collectibleIds: CollectibleId[]): Promise<CollectibleOwnedCountsResponse> => ApiClient.get<CollectibleOwnedCountsResponse>(`${AUTH_BASE}/owned-count`, { collectibleIds }).then(({ data }) => CollectibleOwnedCountsResponse_Schema.parse(data));
